import styled from 'styled-components';

export const ImgHome = styled.img`
    border-radius: 10px;
    padding: 10px;
    margin: 10px;
    border-radius: 15px;
    width: 100%;
    `;

